import {
  httpGet
} from '@/api'
let prefixCourse = '/course/' //课程
let prefixCombo = '/combo/' //套餐
export const courseList = (params) => httpGet(prefixCourse + 'listPageByName', params) // 课程列表
export const comboDetail = (params) => httpGet(prefixCombo + 'details', params) // 套餐详情
export const comboCourseList = (params) => httpGet(prefixCombo + 'comboCourse', params) // 套餐详情